(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9933);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9603);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3024);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _utilities_requestsTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2807);









function Home(param) {
    var carouselProperties = param.carouselProperties;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), email = ref[0], setEmail = ref[1];
    var subscribe = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _utilities_requestsTypes__WEBPACK_IMPORTED_MODULE_4__/* .toBackend.post */ .v.post("", {
                                email: email
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function subscribe() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full bg-primary grid grid-cols-12 text-center md:text-left px-6 pt-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "col-span-12 md:col-span-6 xl:col-span-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " pt-6 pb-4 text-yellow font-medium text-lg text-start",
                        children: "About BartCash"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "text-white flex flex-col gap-y-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/contactus",
                                    className: "hover:text-yellow",
                                    children: "Contact Us"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/faq",
                                    className: "hover:text-yellow",
                                    children: "FAQ's"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    className: "hover:text-yellow",
                                    children: "Terms and conditions"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    className: "hover:text-yellow",
                                    children: "Privacy policy"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    className: "hover:text-yellow",
                                    children: "Track my swap"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "col-span-12 md:col-span-6 xl:col-span-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-6 pb-4 text-yellow font-medium text-lg text-start",
                        children: "Payment"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "text-white flex flex-col gap-y-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "hover:text-yellow",
                                    children: "Verve"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "hover:text-yellow",
                                    children: "Visa"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "hover:text-yellow",
                                    children: "Mastercard"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "hover:text-yellow",
                                    children: "Privacy policy"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "hover:text-yellow",
                                    children: "Wallet"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "col-span-12 md:col-span-6 xl:col-span-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-6 pb-4 text-yellow font-medium text-lg",
                        children: "Connect with Us"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "text-white flex justify-center md:justify-start gap-x-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faTwitter */ .mdU,
                                        className: "w-8 h-8 hover:text-yellow"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faLinkedin */ .D9H,
                                        className: "w-8 h-8 hover:text-yellow"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faFacebook */ .neY,
                                        className: "w-8 h-8 hover:text-yellow"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "text-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faInstagram */ .Zzi,
                                        className: "w-8 h-8 hover:text-yellow"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "col-span-12 md:col-span-6 xl:col-span-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-6 pb-4 text-yellow font-medium text-lg",
                        children: "Get latest products"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex h-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "search",
                                className: "form-control relative w-4/6 flex-auto block px-3 py-1.5 text-base font-normal bg-gray-200 text-gray-700 bg-clip-padding border border-solid border-gray-300 rounded-[10px] transition ease-in-out m-0 focus:text-gray-700 focus:bg-gray-100 focus:outline-none",
                                placeholder: "Email",
                                onChange: function(e) {
                                    setEmail(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "btn inline-block w-2/6 justify-center px-2 ml-[-10px] z-10 py-2.5 bg-yellow text-primary font-medium text-sm leading-tight rounded-r-[10px] hover:text-white hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out flex items-center",
                                type: "button",
                                id: "button-addon2",
                                onClick: subscribe,
                                children: "Subscribe"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between gap-x-2 text-white my-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                className: "flex w-full gap-x-1 p-2 bg-black rounded-[10px] items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faApple */ .Av$,
                                        className: "w-10 h-10"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-left",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "Download on"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "Apple Store"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                className: "flex w-full gap-x-1 p-2 bg-black rounded-[10px] items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faGooglePlay */ .YUQ,
                                        className: "w-10 h-10"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-left",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "Download on"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "Apple Store"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "col-span-12 text-center text-white my-8",
                children: [
                    "Copyright \xa9 ",
                    new Date().getFullYear()
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9417);



function Home(param) {
    var productsProps = param.productsProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_2__/* .faHeart */ .m6i,
        className: "w-6 h-6 text-primary"
    });
}


/***/ }),

/***/ 5502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9603);
/* harmony import */ var _fortawesome_free_regular_svg_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4288);



function Home(param) {
    var productsProps = param.productsProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_regular_svg_icons__WEBPACK_IMPORTED_MODULE_2__/* .faHeart */ .m6i,
        className: "w-6 h-6 text-primary"
    });
}


/***/ }),

/***/ 9933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(9603);
// EXTERNAL MODULE: ./components/Header.js
var Header = __webpack_require__(7673);
// EXTERNAL MODULE: ./components/HeaderNavigation.js
var HeaderNavigation = __webpack_require__(7130);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/Carousel.js



function Home(param) {
    var carouselProperties = param.carouselProperties;
    var ref = (0,react.useState)([]), pictures = ref[0], setPictures = ref[1];
    var ref1 = (0,react.useState)(0), currentImage = ref1[0], setCurrentImage = ref1[1];
    (0,react.useEffect)(function() {
        setPictures(carouselProperties);
        setTimeout(function() {
            if (currentImage == pictures.length - 1) {
                setCurrentImage(0);
                return;
            }
            setCurrentImage(currentImage + 1);
        }, 5000);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "carouselExampleSlidesOnly",
        className: "carousel my-10 mx-6 slide relative",
        "data-bs-ride": "carousel",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "absolute md:right-5 right-2 z-40 md:bottom-5 text-xs bottom-2 bg-primary px-2 py-1 md:py-4 md:px-6 text-white z-10 hover:bg-yellow hover:text-primary rounded-[10px]",
                children: "Start swapping"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "carousel-indicators absolute z-40 right-0 bottom-0 left-0 flex gap-x-2 justify-center p-0 mb-2 md:mb-10",
                children: pictures.map(function(ele, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        // data-bs-target="#carouselExampleCaptions"
                        // data-bs-slide-to="0"
                        // aria-current="true"
                        // aria-label="Slide 1"
                        className: "".concat(index == currentImage ? "bg-yellow h-2 w-4 rounded-[10px]" : "bg-gray-400 h-2 w-2 rounded-full")
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "carousel-inner relative w-full h-[180px] md:h-[360px] xl:h-[650px] rounded-[20px] overflow-hidden",
                children: pictures.map(function(ele, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "carousel-item ".concat(index == currentImage ? "active z-20" : "z-10", " block relative float-left w-full"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                layout: "responsive",
                                width: 12,
                                height: 8,
                                src: "/images/".concat(ele.url),
                                // className="block w-full"
                                alt: "..."
                            }),
                            ele.writeup
                        ]
                    }, index);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 5 modules
var _to_consumable_array = __webpack_require__(797);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9417);
// EXTERNAL MODULE: ./components/hearts/Liked.js
var Liked = __webpack_require__(4740);
// EXTERNAL MODULE: ./components/hearts/NotLiked.js
var NotLiked = __webpack_require__(5502);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var dist_index_es = __webpack_require__(8533);
;// CONCATENATED MODULE: ./components/Products.js
// import { useState, useEffect } from 'react';














function Products_Home(param) {
    var productsProps = param.productsProps, getProducts = param.getProducts, setProducts = param.setProducts;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)("1"), startFrom = ref[0], updateStartFrom = ref[1];
    console.log(productsProps);
    var addNewProducts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newProduct;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getProducts(startFrom)
                        ];
                    case 1:
                        newProduct = _state.sent();
                        console.log(newProduct);
                        setProducts(function(p) {
                            return (0,_to_consumable_array/* default */.Z)(p).concat((0,_to_consumable_array/* default */.Z)(newProduct));
                        });
                        updateStartFrom(startFrom + 1);
                        return [
                            2
                        ];
                }
            });
        });
        return function addNewProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full px-6 pb-6 pt-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-yellow text-primary text-center py-4 mb-2 font-bold font-[40px]",
                children: productsProps.productTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 md:grid-cols-12 gap-y-6 gap-x-4 md:gap-y-10 md:gap-x-14 xl:gap-x-8 w-full my-10",
                children: productsProps.products.docs.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto text-[60px] col-span-2 md:col-span-12",
                    children: "No Product"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* default */.Z, {
                    dataLength: productsProps.products.docs.length,
                    next: addNewProducts,
                    hasMore: productsProps.products.hasNextPage,
                    loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: "Loading... Please Wait"
                    }),
                    endMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: "No more products"
                    }),
                    children: productsProps.products.docs.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-1 md:col-span-4 xl:col-span-2 border border-[1px] border-solid p-2 border-yellow rounded-[20px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between rounded-[20px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: product.user.profilePicUrl,
                                            layout: "intrinsic",
                                            alt: "".concat(product.user.fullName, "'s picture"),
                                            className: "rounded-full",
                                            width: 35,
                                            height: 35
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[16px] md:text-[20px] font-medium",
                                            children: product.user.fullName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: product.favouriteByMe ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Liked/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NotLiked/* default */.Z, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full text-center my-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: product.product.mainImage,
                                            layout: "intrinsic",
                                            alt: product.product.name,
                                            height: 80,
                                            width: 100
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[#262626] text-[16px] font-medium",
                                            children: product.product.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-center font-semibold text-[14px] items-center",
                                            children: [
                                                "N",
                                                product.product.price,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faTag */.LEN,
                                                    className: "w-4 h-6 text-primary ml-2"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function() {
                                        router.push("/product/" + product.product._id);
                                    },
                                    className: "text-center w-full bg-primary flex items-center justify-center font-bold rounded-[20px] py-2 text-white text-[14px]",
                                    children: [
                                        "Swap ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineSwap */.t4O, {
                                            className: "text-white text-[20px] ml-2"
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(3299);
// EXTERNAL MODULE: ./utilities/requestsTypes.js
var requestsTypes = __webpack_require__(2807);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(1444);
;// CONCATENATED MODULE: ./pages/index.js





// import styles from '../styles/Home.module.css'












function pages_Home() {
    var ref = (0,react.useState)({
        productTitle: "Hot Deals",
        products: {
            docs: [],
            page: 1,
            totalPages: 0,
            totalDocs: 0,
            limit: 10,
            hasPrevPage: false,
            hasNextPage: false
        }
    }), productsProps = ref[0], setProducts = ref[1];
    var data = (0,next_auth_react.useSession)().data;
    // const auth = getAuth(app);
    // const showUser = () => {
    //   onAuthStateChanged(auth, (user) => {
    //     console.log(user);
    //   });
    //   console.log(authUser);
    // }
    (0,react.useEffect)(function() {
        getProducts();
    }, []);
    // useEffect(() => {
    //   console.log(authUser);
    // }, [authUser]);
    var getProducts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var page, limit, results, error;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        page = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1, limit = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 10;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            requestsTypes/* toBackend.get */.v.get("products/all-products", {
                                headers: {
                                    accesstoken: data && data.user.token ? data.user.token : null
                                }
                            })
                        ];
                    case 2:
                        results = _state.sent();
                        console.log(results.data);
                        setProducts({
                            productTitle: "Hot Deals",
                            products: results.data
                        });
                        console.log(results.data);
                        console.log("Here");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,react.useState)([
        {
            url: "65aecca1f6488041a9f221f84fe1b12e.jpeg",
            writeup: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute left-[50%] flex flex-col gap-y-4 md:gap-y-6 xl:gap-y-10 leading-5 md:leading-10 top-[50%] z-10 translate-y-[-50%] translate-x-[-50%] xl:text-[48px] text-xl xl:w-[480px] w-[200px] font-bold text-white text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Save more money"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "when you buy less "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "and ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-yellow",
                                children: "swap"
                            }),
                            " more"
                        ]
                    })
                ]
            })
        },
        {
            url: "windowsphone.jpg",
            writeup: ""
        },
        {
            url: "library.jpg",
            writeup: ""
        }
    ]), carProps = ref1[0], setCarousel = ref1[1];
    // const [popularProducts, setPopularProducts] = useState({
    //   productTitle: "Popular Products",
    //   products: []
    // });
    // const [recommendedProducts, setRecommendedProducts] = useState({
    //   productTitle: "Recommended",
    //   products: []
    // });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "BartCash"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigation/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {
                carouselProperties: carProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_Home, {
                productsProps: productsProps,
                getProducts: getProducts,
                setProducts: setProducts
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,4976,7948,5675,9603,6068,4949,1910,4022,716,9774,2888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);